module.exports = __webpack_public_path__ + "images/Automating Ostrom for Effective DAO Management.pdf?v=bff94b4a1d71cbd47178412b9937fa6d";